import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiCheck } = FiIcons;

const SupportedPlatforms = () => {
  const platforms = [
    {
      name: 'YouTube',
      description: 'Extract thumbnails from YouTube videos',
      example: 'https://youtube.com/watch?v=dQw4w9WgXcQ',
      supported: true
    },
    {
      name: 'Vimeo',
      description: 'Extract thumbnails from Vimeo videos',
      example: 'https://vimeo.com/123456789',
      supported: true
    },
    {
      name: 'Dailymotion',
      description: 'Extract thumbnails from Dailymotion videos',
      example: 'https://dailymotion.com/video/x123456',
      supported: true
    },
    {
      name: 'Custom URLs',
      description: 'Direct video file URLs with thumbnails',
      example: 'https://example.com/video.mp4',
      supported: true
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">
          Supported Platforms
        </h3>
        <p className="text-gray-600">
          We support thumbnail extraction from these platforms
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {platforms.map((platform, index) => (
          <motion.div
            key={platform.name}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="bg-gray-50 rounded-xl p-6 border border-gray-200"
          >
            <div className="flex items-start space-x-4">
              <div className="bg-indigo-100 p-2 rounded-lg">
                <SafeIcon icon={FiPlay} className="text-indigo-600" />
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <h4 className="font-semibold text-gray-800">{platform.name}</h4>
                  {platform.supported && (
                    <SafeIcon icon={FiCheck} className="text-green-500" />
                  )}
                </div>
                <p className="text-gray-600 text-sm mb-3">
                  {platform.description}
                </p>
                <code className="text-xs bg-gray-200 px-2 py-1 rounded text-gray-700">
                  {platform.example}
                </code>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
        <h4 className="font-semibold text-blue-800 mb-2">How it works</h4>
        <ul className="text-blue-700 text-sm space-y-1">
          <li>• Paste any supported video URL above</li>
          <li>• We'll extract all available thumbnail sizes</li>
          <li>• Choose your preferred quality and download</li>
          <li>• All processing happens in your browser</li>
        </ul>
      </div>
    </div>
  );
};

export default SupportedPlatforms;